import {
  ICurrentOrganisation,
  IOrganisationUser,
  IOrganisationUserEdit,
  IOrganisationUserInvite,
  IOrganisationUserInvitation,
} from '@liquid-state/pephealth-client';
import { DirectChildOrganisation } from './client';

export const LOAD_CURRENT_ORGANISATION =
  'direct-child-organisation-administration/load-current-organisation';
export const LOAD_CURRENT_ORGANISATION_SUCCESS =
  'direct-child-organisation-administration/load-current-organisation-success';
export const LOAD_CURRENT_ORGANISATION_FAILURE =
  'direct-child-organisation-administration/load-current-organisation-failure';
export const LOAD_DIRECT_CHILD_ORGANISATIONS =
  'direct-child-organisation-administration/load-direct-child-organisations';
export const LOAD_DIRECT_CHILD_ORGANISATIONS_SUCCESS =
  'direct-child-organisation-administration/load-direct-child-organisations-success';
export const LOAD_DIRECT_CHILD_ORGANISATIONS_FAILURE =
  'direct-child-organisation-administration/load-direct-child-organisations-failure';
export const LOAD_DIRECT_CHILD_ORGANISATION =
  'direct-child-organisation-administration/load-direct-child-organisation';
export const LOAD_DIRECT_CHILD_ORGANISATION_SUCCESS =
  'direct-child-organisation-administration/load-direct-child-organisation-success';
export const LOAD_DIRECT_CHILD_ORGANISATION_FAILURE =
  'direct-child-organisation-administration/load-direct-child-organisation-failure';
export const CREATE_DIRECT_CHILD_ORGANISATION =
  'direct-child-organisation-administration/create-direct-child-organisation';
export const CREATE_DIRECT_CHILD_ORGANISATION_SUCCESS =
  'direct-child-organisation-administration/create-direct-child-organisation-success';
export const CREATE_DIRECT_CHILD_ORGANISATION_FAILURE =
  'direct-child-organisation-administration/create-direct-child-organisation-failure';
export const RESET_DIRECT_CHILD_ORGANISATION_CREATION =
  'direct-child-organisation-administration/reset-direct-child-organisation-creation';
export const LOAD_DIRECT_CHILD_ORGANISATION_USERS =
  'direct-child-organisation-administration/load-direct-child-organisation-users';
export const LOAD_DIRECT_CHILD_ORGANISATION_USERS_SUCCESS =
  'direct-child-organisation-administration/load-direct-child-organisation-users-success';
export const LOAD_DIRECT_CHILD_ORGANISATION_USERS_FAILURE =
  'direct-child-organisation-administration/load-direct-child-organisation-users-failure';
export const INVITE_DIRECT_CHILD_ORGANISATION_USER =
  'direct-child-organisation-administration/invite-direct-child-organisation-user';
export const INVITE_DIRECT_CHILD_ORGANISATION_USER_SUCCESS =
  'direct-child-organisation-administration/invite-direct-child-organisation-user-success';
export const INVITE_DIRECT_CHILD_ORGANISATION_USER_FAILURE =
  'direct-child-organisation-administration/invite-direct-child-organisation-user-failure';
export const RESET_DIRECT_CHILD_ORGANISATION_USER_INVITATION =
  'direct-child-organisation-administration/reset-direct-child-organisation-user-invitation';
export const LOAD_DIRECT_CHILD_ORGANISATION_USER_DETAILS =
  'direct-child-organisation-administration/load-direct-child-organisation-user-details';
export const LOAD_DIRECT_CHILD_ORGANISATION_USER_DETAILS_SUCCESS =
  'direct-child-organisation-administration/load-direct-child-organisation-user-details-success';
export const LOAD_DIRECT_CHILD_ORGANISATION_USER_DETAILS_FAILURE =
  'direct-child-organisation-administration/load-direct-child-organisation-user-details-failure';
export const RESEND_DIRECT_CHILD_ORGANISATION_USER_INVITATION =
  'direct-child-organisation-administration/resend-direct-child-organisation-user-invitation';
export const RESEND_DIRECT_CHILD_ORGANISATION_USER_INVITATION_SUCCESS =
  'direct-child-organisation-administration/resend-direct-child-organisation-user-invitation-success';
export const RESEND_DIRECT_CHILD_ORGANISATION_USER_INVITATION_FAILURE =
  'direct-child-organisation-administration/resend-direct-child-organisation-user-invitation-failure';
export const EDIT_DIRECT_CHILD_ORGANISATION_USER =
  'direct-child-organisation-administration/edit-direct-child-organisation-user';
export const EDIT_DIRECT_CHILD_ORGANISATION_USER_SUCCESS =
  'direct-child-organisation-administration/edit-direct-child-organisation-user-success';
export const EDIT_DIRECT_CHILD_ORGANISATION_USER_FAILURE =
  'direct-child-organisation-administration/edit-direct-child-organisation-user-failure';
export const RESET_DIRECT_CHILD_ORGANISATION_USER_EDIT =
  'direct-child-organisation-administration/reset-direct-child-organisation-user-edit';
export const UPDATE_DIRECT_CHILD_ORGANISATION_USER_PROFILE_PICTURE =
  'direct-child-organisation-administration/update-direct-child-organisation-user-profile-picture';

export const loadCurrentOrganisation = () => ({
  type: LOAD_CURRENT_ORGANISATION as typeof LOAD_CURRENT_ORGANISATION,
});

export const loadCurrentOrganisationSuccess = (organisation: ICurrentOrganisation) => ({
  type: LOAD_CURRENT_ORGANISATION_SUCCESS as typeof LOAD_CURRENT_ORGANISATION_SUCCESS,
  payload: { organisation },
});

export const loadCurrentOrganisationFailure = (error: string) => ({
  type: LOAD_CURRENT_ORGANISATION_FAILURE as typeof LOAD_CURRENT_ORGANISATION_FAILURE,
  payload: { error },
});

export const loadDirectChildOrganisations = () => ({
  type: LOAD_DIRECT_CHILD_ORGANISATIONS as typeof LOAD_DIRECT_CHILD_ORGANISATIONS,
});

export const loadDirectChildOrganisationsSuccess = (organisations: DirectChildOrganisation[]) => ({
  type: LOAD_DIRECT_CHILD_ORGANISATIONS_SUCCESS as typeof LOAD_DIRECT_CHILD_ORGANISATIONS_SUCCESS,
  payload: { organisations },
});

export const loadDirectChildOrganisationsFailure = (
  error: string,
  status?: number,
  errorCode?: string,
) => ({
  type: LOAD_DIRECT_CHILD_ORGANISATIONS_FAILURE as typeof LOAD_DIRECT_CHILD_ORGANISATIONS_FAILURE,
  payload: { error, status, errorCode },
});

export const loadDirectChildOrganisation = (organisationSlug: string) => ({
  type: LOAD_DIRECT_CHILD_ORGANISATION as typeof LOAD_DIRECT_CHILD_ORGANISATION,
  payload: { organisationSlug },
});

export const loadDirectChildOrganisationSuccess = (organisation: DirectChildOrganisation) => ({
  type: LOAD_DIRECT_CHILD_ORGANISATION_SUCCESS as typeof LOAD_DIRECT_CHILD_ORGANISATION_SUCCESS,
  payload: { organisation },
});

export const loadDirectChildOrganisationFailure = (
  organisationSlug: string,
  error: string,
  status?: number,
) => ({
  type: LOAD_DIRECT_CHILD_ORGANISATION_FAILURE as typeof LOAD_DIRECT_CHILD_ORGANISATION_FAILURE,
  payload: { organisationSlug, error, status },
});

export const createDirectChildOrganisation = (name: string, language: string) => ({
  type: CREATE_DIRECT_CHILD_ORGANISATION as typeof CREATE_DIRECT_CHILD_ORGANISATION,
  payload: { name, language },
});

export const createDirectChildOrganisationSuccess = () => ({
  type: CREATE_DIRECT_CHILD_ORGANISATION_SUCCESS as typeof CREATE_DIRECT_CHILD_ORGANISATION_SUCCESS,
});

export const createDirectChildOrganisationFailure = () => ({
  type: CREATE_DIRECT_CHILD_ORGANISATION_FAILURE as typeof CREATE_DIRECT_CHILD_ORGANISATION_FAILURE,
});

export const resetDirectChildOrganisationCreation = () => ({
  type: RESET_DIRECT_CHILD_ORGANISATION_CREATION as typeof RESET_DIRECT_CHILD_ORGANISATION_CREATION,
});

export interface DirectChildOrganisationUsersResult {
  organisation: DirectChildOrganisation;
  users: IOrganisationUser[];
}

export const loadDirectChildOrganisationUsers = () => ({
  type: LOAD_DIRECT_CHILD_ORGANISATION_USERS as typeof LOAD_DIRECT_CHILD_ORGANISATION_USERS,
});

export const loadDirectChildOrganisationUsersSuccess = (
  results: DirectChildOrganisationUsersResult[],
) => ({
  type: LOAD_DIRECT_CHILD_ORGANISATION_USERS_SUCCESS as typeof LOAD_DIRECT_CHILD_ORGANISATION_USERS_SUCCESS,
  payload: { results },
});

export const loadDirectChildOrganisationUsersFailure = (error: string, status?: number) => ({
  type: LOAD_DIRECT_CHILD_ORGANISATION_USERS_FAILURE as typeof LOAD_DIRECT_CHILD_ORGANISATION_USERS_FAILURE,
  payload: { error, status },
});

export const inviteDirectChildOrganisationUser = (
  organisationSlug: string,
  invite: IOrganisationUserInvite,
) => ({
  type: INVITE_DIRECT_CHILD_ORGANISATION_USER as typeof INVITE_DIRECT_CHILD_ORGANISATION_USER,
  payload: { organisationSlug, invite },
});

export const inviteDirectChildOrganisationUserSuccess = () => ({
  type: INVITE_DIRECT_CHILD_ORGANISATION_USER_SUCCESS as typeof INVITE_DIRECT_CHILD_ORGANISATION_USER_SUCCESS,
});

export const inviteDirectChildOrganisationUserFailure = () => ({
  type: INVITE_DIRECT_CHILD_ORGANISATION_USER_FAILURE as typeof INVITE_DIRECT_CHILD_ORGANISATION_USER_FAILURE,
});

export const resetDirectChildOrganisationUserInvitation = () => ({
  type: RESET_DIRECT_CHILD_ORGANISATION_USER_INVITATION as typeof RESET_DIRECT_CHILD_ORGANISATION_USER_INVITATION,
});

export const loadDirectChildOrganisationUserDetails = (
  organisationSlug: string,
  userId: number,
) => ({
  type: LOAD_DIRECT_CHILD_ORGANISATION_USER_DETAILS as typeof LOAD_DIRECT_CHILD_ORGANISATION_USER_DETAILS,
  payload: { organisationSlug, userId },
});

export const loadDirectChildOrganisationUserDetailsSuccess = (
  organisation: DirectChildOrganisation,
  user: IOrganisationUser,
  invitations: IOrganisationUserInvitation[],
) => ({
  type: LOAD_DIRECT_CHILD_ORGANISATION_USER_DETAILS_SUCCESS as typeof LOAD_DIRECT_CHILD_ORGANISATION_USER_DETAILS_SUCCESS,
  payload: { organisation, user, invitations },
});

export const loadDirectChildOrganisationUserDetailsFailure = (
  organisationSlug: string,
  userId: number,
  error: string,
  status?: number,
) => ({
  type: LOAD_DIRECT_CHILD_ORGANISATION_USER_DETAILS_FAILURE as typeof LOAD_DIRECT_CHILD_ORGANISATION_USER_DETAILS_FAILURE,
  payload: { organisationSlug, userId, error, status },
});

export const resendDirectChildOrganisationUserInvitation = (
  organisationSlug: string,
  userId: number,
) => ({
  type: RESEND_DIRECT_CHILD_ORGANISATION_USER_INVITATION as typeof RESEND_DIRECT_CHILD_ORGANISATION_USER_INVITATION,
  payload: { organisationSlug, userId },
});

export const resendDirectChildOrganisationUserInvitationSuccess = (
  organisationSlug: string,
  userId: number,
) => ({
  type: RESEND_DIRECT_CHILD_ORGANISATION_USER_INVITATION_SUCCESS as typeof RESEND_DIRECT_CHILD_ORGANISATION_USER_INVITATION_SUCCESS,
  payload: { organisationSlug, userId },
});

export const resendDirectChildOrganisationUserInvitationFailure = (
  organisationSlug: string,
  userId: number,
) => ({
  type: RESEND_DIRECT_CHILD_ORGANISATION_USER_INVITATION_FAILURE as typeof RESEND_DIRECT_CHILD_ORGANISATION_USER_INVITATION_FAILURE,
  payload: { organisationSlug, userId },
});

export const editDirectChildOrganisationUser = (
  organisationSlug: string,
  userId: number,
  edit: IOrganisationUserEdit,
) => ({
  type: EDIT_DIRECT_CHILD_ORGANISATION_USER as typeof EDIT_DIRECT_CHILD_ORGANISATION_USER,
  payload: { organisationSlug, userId, edit },
});

export const editDirectChildOrganisationUserSuccess = (
  organisationSlug: string,
  userId: number,
) => ({
  type: EDIT_DIRECT_CHILD_ORGANISATION_USER_SUCCESS as typeof EDIT_DIRECT_CHILD_ORGANISATION_USER_SUCCESS,
  payload: { organisationSlug, userId },
});

export const editDirectChildOrganisationUserFailure = (
  organisationSlug: string,
  userId: number,
) => ({
  type: EDIT_DIRECT_CHILD_ORGANISATION_USER_FAILURE as typeof EDIT_DIRECT_CHILD_ORGANISATION_USER_FAILURE,
  payload: { organisationSlug, userId },
});

export const resetDirectChildOrganisationUserEdit = (organisationSlug: string, userId: number) => ({
  type: RESET_DIRECT_CHILD_ORGANISATION_USER_EDIT as typeof RESET_DIRECT_CHILD_ORGANISATION_USER_EDIT,
  payload: { organisationSlug, userId },
});

export const updateDirectChildOrganisationUserProfilePicture = (
  userId: number,
  picture: { profilePictureImageId: string | null; profilePictureUrl: string | null },
) => ({
  type: UPDATE_DIRECT_CHILD_ORGANISATION_USER_PROFILE_PICTURE as typeof UPDATE_DIRECT_CHILD_ORGANISATION_USER_PROFILE_PICTURE,
  payload: { userId, picture },
});

export type DirectChildOrganisationAdministrationAction =
  | ReturnType<typeof loadCurrentOrganisation>
  | ReturnType<typeof loadCurrentOrganisationSuccess>
  | ReturnType<typeof loadCurrentOrganisationFailure>
  | ReturnType<typeof loadDirectChildOrganisations>
  | ReturnType<typeof loadDirectChildOrganisationsSuccess>
  | ReturnType<typeof loadDirectChildOrganisationsFailure>
  | ReturnType<typeof loadDirectChildOrganisation>
  | ReturnType<typeof loadDirectChildOrganisationSuccess>
  | ReturnType<typeof loadDirectChildOrganisationFailure>
  | ReturnType<typeof createDirectChildOrganisation>
  | ReturnType<typeof createDirectChildOrganisationSuccess>
  | ReturnType<typeof createDirectChildOrganisationFailure>
  | ReturnType<typeof resetDirectChildOrganisationCreation>
  | ReturnType<typeof loadDirectChildOrganisationUsers>
  | ReturnType<typeof loadDirectChildOrganisationUsersSuccess>
  | ReturnType<typeof loadDirectChildOrganisationUsersFailure>
  | ReturnType<typeof inviteDirectChildOrganisationUser>
  | ReturnType<typeof inviteDirectChildOrganisationUserSuccess>
  | ReturnType<typeof inviteDirectChildOrganisationUserFailure>
  | ReturnType<typeof resetDirectChildOrganisationUserInvitation>
  | ReturnType<typeof loadDirectChildOrganisationUserDetails>
  | ReturnType<typeof loadDirectChildOrganisationUserDetailsSuccess>
  | ReturnType<typeof loadDirectChildOrganisationUserDetailsFailure>
  | ReturnType<typeof resendDirectChildOrganisationUserInvitation>
  | ReturnType<typeof resendDirectChildOrganisationUserInvitationSuccess>
  | ReturnType<typeof resendDirectChildOrganisationUserInvitationFailure>
  | ReturnType<typeof editDirectChildOrganisationUser>
  | ReturnType<typeof editDirectChildOrganisationUserSuccess>
  | ReturnType<typeof editDirectChildOrganisationUserFailure>
  | ReturnType<typeof resetDirectChildOrganisationUserEdit>
  | ReturnType<typeof updateDirectChildOrganisationUserProfilePicture>;
